export default {"src":"/_next/static/media/Migraine.d1acda04.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};